import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
//import { InfoConnection } from "src/app/info-connection";
import { HttpClient } from '@angular/common/http';
import { DialogContentExampleDialog } from '../dialogCreerElement/dialogCreerElement';
//import { CUtilit } from "src/app/utilit";


// Corriger les pb d'import avec le server

@Component({
  // tslint:disable-next-line:component-selector
    selector: 'dialog-content-nouveau-deco',
    templateUrl: 'dialog-content-nouveau-deco.html',
    styleUrls: ['dialog-content-nouveau-deco.css']
})
// tslint:disable-next-line:component-class-suffix
export class DialogContentNouveauDeco {

    private mCodeChantier?: string; // Utiliser pour l'input de séléction du code chantier
    mChargerLaListeDesChantier: boolean;
    mCodeDecorticageAttribue?: string;
    mBoolCreationDuDecoEnCours: boolean;

    constructor(public dialogRef: MatDialogRef<DialogContentExampleDialog>,
        private httpClient: HttpClient,
        private _snackBar: MatSnackBar,
        @Inject(MAT_DIALOG_DATA) public data: any) {
        this.mChargerLaListeDesChantier = false;
        this.mBoolCreationDuDecoEnCours = false;
    }

    private chargerListDecorticage() {
        this.mChargerLaListeDesChantier = true;
    }

    /**
     * Envoie une requete pour confirmer que le chantier existe et retourne le code decorticage utiliser pour la création
     * Appeler dans le HTML
     */
    public verifierCodeChantier(newCodeChantier: string) {
        console.log('Code rentrée: ', newCodeChantier);
        if (newCodeChantier != this.mCodeChantier) {
            this.mCodeChantier = newCodeChantier;
            if (this.mCodeChantier != '') {
                /*let connection = InfoConnection.CreateFromStaticInformation(this.httpClient);
                connection.GETFunction('GetCodeContratCreation', [this.mCodeChantier]).subscribe(
                    val => {
                        this.mCodeDecorticageAttribue = DecoUtils.getValueFromHttpCodeDeco(val);
                        if (!this.mCodeDecorticageAttribue) {
                            console.warn(DecoUtils.getErrorFromHttpCodeDeco(val));
                            CUtilit.showSnackBar(this._snackBar, DecoUtils.getErrorFromHttpCodeDeco(val));
                        }
                    },
                    error => {
                        CUtilit.showSnackBar(this._snackBar, error.message);
                        console.error(error.message);
                        this.mCodeDecorticageAttribue = '';
                        this.mCodeChantier = '';
                    }
                );*/
            } else {
                console.log('Pas d\'actualisation car code invalide');
                this.mCodeDecorticageAttribue = undefined;
            }
        } else {
            console.log('On actualisa pas meme code rentrée');
        }
    }

    private creeDecorticage() {

    }

    public validerDecorticage() {
        if (this.mBoolCreationDuDecoEnCours) {
            this.dialogRef.close(true);
        }
        this.mBoolCreationDuDecoEnCours = true;
        /*let connection = InfoConnection.CreateFromStaticInformation(this.httpClient);
        connection.GETFunction('CreeContrat', [this.mCodeChantier]).subscribe(
            next => {
                console.log('next: ', next)
            },
            error => {
                console.log('error: ', error);
                this.mBoolCreationDuDecoEnCours = false;
            },
            () => {
                console.log('complete');
                this.mBoolCreationDuDecoEnCours = false;
                let result = {
                    'validite': true,
                    'codeDeco': this.mCodeDecorticageAttribue
                }
                this.dialogRef.close(result);
            }
        );*/
    }
}

export class DecoUtils {
    public static getValueFromHttpCodeDeco(val: any): string {
        return val.result[0].Result;
    }

    public static getErrorFromHttpCodeDeco(val: any): string {
        return val.result[0].Erreur;
    }
}
